'use strict';

const index = require('./index-4474431a.js');

const CheckFilterIcon = () => (index.h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
  index.h("rect", { x: "2", y: "2", width: "20", height: "20", rx: "4", fill: "white" }),
  index.h("path", { d: "M10.8765 13.5061L16.1943 8.30769C16.4041 8.10256 16.6526 8 16.9398 8C17.2269 8 17.4754 8.10256 17.6852 8.30769C17.8951 8.51282 18 8.75574 18 9.03644C18 9.31714 17.8951 9.56005 17.6852 9.76518L11.622 15.6923C11.4121 15.8974 11.1637 16 10.8765 16C10.5894 16 10.3409 15.8974 10.131 15.6923L7.31476 12.9393C7.10492 12.7341 7 12.4912 7 12.2105C7 11.9298 7.10492 11.6869 7.31476 11.4818C7.5246 11.2767 7.77309 11.1741 8.06024 11.1741C8.34739 11.1741 8.59588 11.2767 8.80572 11.4818L10.8765 13.5061Z", fill: "#161616" })));

const CloseFilterIcon = () => (index.h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
  index.h("path", { d: "M12 13.4L7.09999 18.3C6.91665 18.4834 6.68332 18.575 6.39999 18.575C6.11665 18.575 5.88332 18.4834 5.69999 18.3C5.51665 18.1167 5.42499 17.8834 5.42499 17.6C5.42499 17.3167 5.51665 17.0834 5.69999 16.9L10.6 12L5.69999 7.10005C5.51665 6.91672 5.42499 6.68338 5.42499 6.40005C5.42499 6.11672 5.51665 5.88338 5.69999 5.70005C5.88332 5.51672 6.11665 5.42505 6.39999 5.42505C6.68332 5.42505 6.91665 5.51672 7.09999 5.70005L12 10.6L16.9 5.70005C17.0833 5.51672 17.3167 5.42505 17.6 5.42505C17.8833 5.42505 18.1167 5.51672 18.3 5.70005C18.4833 5.88338 18.575 6.11672 18.575 6.40005C18.575 6.68338 18.4833 6.91672 18.3 7.10005L13.4 12L18.3 16.9C18.4833 17.0834 18.575 17.3167 18.575 17.6C18.575 17.8834 18.4833 18.1167 18.3 18.3C18.1167 18.4834 17.8833 18.575 17.6 18.575C17.3167 18.575 17.0833 18.4834 16.9 18.3L12 13.4Z", fill: "#8D8D8D" })));

const SquareFilterIcon = () => (index.h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
  index.h("rect", { x: "3", y: "3", width: "20", height: "20", rx: "3", fill: "white", stroke: "#E0E0E0", "stroke-width": "2" })));

const subFilterSelection = (filters, { column: selectedColumn }, filterValue) => {
  var _a, _b, _c;
  const value = (_b = (_a = filterValue.interval) !== null && _a !== void 0 ? _a : filterValue.value) !== null && _b !== void 0 ? _b : filterValue;
  const index = filters.findIndex(({ column }) => column === selectedColumn);
  const valueIndex = (_c = filters[index]) === null || _c === void 0 ? void 0 : _c.values.findIndex((val) => val === value);
  const action = valueIndex == -1 || index == -1 ? "select" : "deselect";
  const pushObject = index === -1 || selectedColumn === "price"
    ? { column: selectedColumn, values: [] }
    : filters[index];
  if (valueIndex > -1)
    pushObject.values.splice(valueIndex, 1);
  else
    pushObject.values.push(value);
  if (index === -1) {
    filters = [...filters, pushObject];
    if (document.getElementById("filters-footer"))
      document.getElementById("filters-footer").scrollLeft = 0;
  }
  else {
    filters[index] = pushObject;
    if (filters[index].values.length === 0) {
      filters = [...filters.filter((filter) => filters[index] !== filter)];
    }
    else {
      filters = [...filters];
    }
  }
  return { filters, action };
};

const RenderButton = (handleSubFilterSelection, value, label, active, selectedFilter, isSelected = false, showClose = false) => {
  const hexCode = value.hexCode;
  const hasHexCodeLength = (hexCode === null || hexCode === void 0 ? void 0 : hexCode.length) > 0;
  return (index.h("li", { part: "filters-sub-row" },
    index.h("button", { onClick: () => handleSubFilterSelection(value, selectedFilter), class: `filters-more-modal-button ${hasHexCodeLength ? "filters-sub-button-color" : ""} ${isSelected ? "active" : ""}`, disabled: !active, part: "filters-option-button" },
      hasHexCodeLength && (index.h("div", { class: "filters-sub-button-color-dot", style: { backgroundColor: hexCode }, part: "filters-option-color-dot" })),
      index.h("span", null,
        index.h("span", { part: "filters-option-text" }, label),
        index.h("div", { part: "filters-option-icon-wrapper" }, !showClose ? (isSelected ? (index.h(CheckFilterIcon, null)) : (index.h(SquareFilterIcon, null))) : null),
        isSelected && showClose && index.h(CloseFilterIcon, null)))));
};

const showActiveOnSubButton = (requestFilters, filterValue, selectedFilter) => {
  if (!selectedFilter || !requestFilters)
    return false;
  const mainFilter = requestFilters.find(({ column }) => column === selectedFilter.column);
  if (!mainFilter)
    return false;
  return mainFilter.values.some((value) => value === filterValue ||
    value === filterValue.interval ||
    value === filterValue.value)
    ? true
    : false;
};

const triggerFilter = (filterValue, selectedFilter, requestFilters, vviinnFilterTriggered, vviinnFiltersChanged, el, isTriggeredByVpsWidget) => {
  const { filters, action } = subFilterSelection(requestFilters, selectedFilter, filterValue);
  vviinnFilterTriggered.emit({
    kind: selectedFilter.column,
    action,
  });
  vviinnFiltersChanged.emit({
    filters,
    el,
    isTriggeredByVpsWidget,
  });
  return filters;
};
const triggerResetFilters = (vviinnFiltersChanged, el, isTriggeredByVpsWidget) => {
  // TODO: #37391 Implement the reset logic
  // vviinnFilterTriggered.emit({
  //   action: "reset",
  // });
  vviinnFiltersChanged.emit({
    filters: [],
    el,
    isTriggeredByVpsWidget,
  });
};

exports.RenderButton = RenderButton;
exports.showActiveOnSubButton = showActiveOnSubButton;
exports.triggerFilter = triggerFilter;
exports.triggerResetFilters = triggerResetFilters;
